<template>
    <div class="range-slider">
        <div
            id="range-slider"
            role="slider"
            ref="slider"
            aria-label="Spendenziel"
        ></div>
    </div>
</template>

<script>
import noUiSlider from 'nouislider'

export default {
    name: 'RangeSlider',

    props: {
        value: {
            type: Number,
            default: 0
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 10000
        },
        step: {
            type: Number,
            default: 1
        }
    },

    data () {
        return {
            instance: null
        }
    },

    mounted () {
        this.init()
    },

    methods: {
        init () {
            this.instance = noUiSlider.create(this.$refs.slider, {
                start: this.value,
                connect: [true, false],
                range: {
                    min: this.min,
                    max: this.max
                },
                step: this.step,
                tooltips: this.format(),
                pips: {
                    mode: 'count',
                    values: 6,
                    density: 6,
                    format: this.format()
                }
            })

            this.bindListener()
        },

        bindListener () {
            this.instance.on('change', event => {
                const value = parseInt(event[0])
                this.$emit('input', value)
            })
        },

        update () {
            this.instance.set(this.value)
        },

        format () {
            return {
                to (value) {
                    return value + '€'
                },
                from (value) {
                    return value.replace('€', '')
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/elements/RangeSlider.vue